<div class="flex flex-col items-center p-4 sm:p-6 bg-[--lightRed] rounded-xl min-h-[80vh] mx-4 sm:mx-8 md:mx-16 lg:mx-[200px] my-5">
  <div class="w-full pb-8">
    <h5 class="text-xs sm:text-sm font-bold text-white mb-4 text-center py-5">
      <i class="bx bx-book-reader text-white"></i> Simulados Disponíveis
    </h5>

    <div *ngIf="isLoading" class="flex justify-center items-center py-6">
      <span class="text-white">Carregando...</span>
    </div>

    <div *ngIf="!isLoading && exams.length > 0" class="space-y-4">
      <div *ngFor="let exam of exams" class="flex flex-col sm:flex-row items-start sm:items-center bg-white shadow-md p-4 rounded-lg border border-gray-200 hover:shadow-lg transition">
        <div class="flex items-center justify-center w-12 h-12 bg-indigo-100 text-indigo-600 rounded-full mb-2 sm:mb-0">
          <i class='bx bx-book-open text-2xl'></i>
        </div>
        <div class="sm:ml-4 flex-1 w-full">
          <span class="text-sm font-semibold text-gray-900">{{ exam.title }}</span>
          <p class="text-sm text-gray-600 truncate w-full sm:w-96">Descrição: {{ exam.description }}</p>
          <p class="text-xs text-gray-500 mt-1">Questões: {{ exam.qcodes.split('/').length }}</p>
          <p class="text-xs text-gray-400">Criado em: {{ exam.created_at }}</p>
        </div>
        <button class="mt-4 sm:mt-0 sm:ml-4 border px-4 py-2 hover:bg-white hover:text-indigo-600 hover:border-indigo-600 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 transition" [routerLink]="['/exam', exam.id]">
          <i class='bx bx-play'></i> Iniciar
        </button>
      </div>
    </div>

    <div *ngIf="!isLoading && exams.length === 0" class="text-gray-500 text-center py-6">
      Nenhum simulado disponível no momento.
    </div>
  </div>
</div>
